import { FiSearch, FiCheckCircle, FiTrendingUp, FiCode, FiUsers } from 'react-icons/fi';
import { HiOutlineAdjustments, HiOutlinePlay, HiOutlineShieldCheck } from 'react-icons/hi';
import { BsDatabaseCheck, BsPersonCheckFill } from 'react-icons/bs';
import { FaMagnifyingGlassDollar } from 'react-icons/fa6';
import { RiRobot2Line } from 'react-icons/ri';
import { BiSupport } from 'react-icons/bi';
import { HiOutlineUserGroup } from 'react-icons/hi2';

import {
  MdAutoAwesome,
  MdPeopleAlt,
  MdOutlineRocketLaunch,
  MdOutlinePsychology,
} from 'react-icons/md';
import { TbPlugConnected, TbBrain, TbChecklist, TbNetwork, TbLifebuoy } from 'react-icons/tb';
import type { IconType } from 'react-icons';
import { FaMedal, FaGlobeAsia } from 'react-icons/fa';
import { HiOutlineCog6Tooth } from 'react-icons/hi2';

export const iconMap: Record<string, IconType> = {
  // Implementation benefits
  clarity: FiSearch,
  bespoke: HiOutlineAdjustments,
  cleanData: BsDatabaseCheck,
  advantage: MdAutoAwesome,
  integration: TbPlugConnected,
  testing: FiCheckCircle,
  training: MdPeopleAlt,
  launch: HiOutlinePlay,
  growth: FiTrendingUp,
  magnifyDollar: FaMagnifyingGlassDollar,
  robot: RiRobot2Line,
  code: FiCode,
  network: TbNetwork,
  award: FaMedal,
  personCheck: BsPersonCheckFill,
  globeAsia: FaGlobeAsia,
  cogTooth: HiOutlineCog6Tooth,

  // Integration benefits
  unifiedBI: TbBrain, // Unified Business Intelligence
  noManualTasks: TbChecklist, // Freedom from Manual Tasks
  perfectFit: HiOutlineAdjustments, // Perfect-Fit Technology
  peaceOfMind: HiOutlineShieldCheck, // Peace of Mind
  techPartner: MdOutlinePsychology, // A Technology Growth Partner
  roiBoost: MdOutlineRocketLaunch, // Accelerated Return on Investment

  // NetSuite Services
  integrations: TbPlugConnected, // NetSuite Integrations
  implementations: MdOutlineRocketLaunch, // NetSuite Implementations
  consulting: FiUsers, // NetSuite Consulting
  managedServices: BiSupport, // Managed Services
  partnerSupport: HiOutlineUserGroup, // Partner Support (White Label)
  rescue: TbLifebuoy, // NetSuite Rescue Service
};
